// extracted by mini-css-extract-plugin
module.exports = {"favorite":"svings-account_favorite_265WG","active":"svings-account_active_3b1Mt"};